// extracted by mini-css-extract-plugin
module.exports = {"mandatory":"SendTestInvitesModal-module_mandatory_7ab4d","backofficeButton":"SendTestInvitesModal-module_backofficeButton_0d1f4"};